import { render, staticRenderFns } from "./ScratchStudy.vue?vue&type=template&id=e5392acc&scoped=true&"
import script from "./ScratchStudy.vue?vue&type=script&lang=js&"
export * from "./ScratchStudy.vue?vue&type=script&lang=js&"
import style0 from "./ScratchStudy.vue?vue&type=style&index=0&id=e5392acc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5392acc",
  null
  
)

export default component.exports